import dayjs from 'dayjs';

import { dateInputFieldFormat } from '~libs/dayjs';
import { buildSlice, CommonState, Row } from '~libs/reduxUtils';

import { typePrefix } from '~weekly-planner/actions';

interface State extends CommonState<Row> {
  params: {
    week_start: string;
    limit: number;
    [key: string]: any;
  };
  date: string;
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  params: {
    week_start: dayjs().weekday(1).format(dateInputFieldFormat),
    limit: 1,
  },
  date: dayjs().format(dateInputFieldFormat),
};

const slice = buildSlice<State>(typePrefix, initialState, {
  customActions: {
    update(state, action) {
      const options = action.payload;

      for (const key of Object.keys(options)) {
        state[key] = options[key];
      }
    },
  },
});

export const { clear, update, updateParams } = slice.actions;

export default slice.reducer;
